import {noop} from '@benchling/js-utils';
import {css} from 'aphrodite';
import React, {useMemo} from 'react';

import {OPERATOR_TO_SECONDARY_LABEL, styles} from 'search/blast/constants';
import {Operator, OPERATOR_TO_TEXT} from 'search/SearchConstants';
import RadioButtonGroup from 'ui-library/inputs/RadioButtonGroup';

export const blastOperators = [
  Operator.BLASTN,
  Operator.BLASTP,
  Operator.BLASTX,
  Operator.TBLASTN,
  Operator.TBLASTX,
] as const;

interface BLASTOperatorToggleGroupProps {
  operator: Operator;
  onChangeType?: (operator: Operator) => void;
}

/**
 * When {@code onChangeType} is defined, users can toggle between the group options.
 * When {@code onChangeType} is undefined, the toggle group is fixed. Only the
 * {@code operator} option is enabled. Other options are shown as disabled.
 * The necessity and design of this component may change in the future when we
 * need to support more BLAST operators.
 */
export default function BLASTOperatorToggleGroup({
  operator,
  onChangeType,
}: BLASTOperatorToggleGroupProps): JSX.Element {
  const options = useMemo(
    () =>
      blastOperators.map((blastOperator) => ({
        id: blastOperator,
        label: <span className={css(styles.blastTypeLabel)}>{OPERATOR_TO_TEXT[blastOperator]}</span>,
        secondaryLabel: OPERATOR_TO_SECONDARY_LABEL[blastOperator],
        value: blastOperator,
      })),
    []
  );
  return (
    <RadioButtonGroup
      selectedValue={operator}
      options={options}
      onChange={onChangeType || noop}
      isVertical={true}
      title=""
      hasBottomSpacing={false}
    />
  );
}
